import type { ReactNode } from 'react';

export const symbol_car_fan_mid_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M564-55q-11 6-23 2.91T523-66L419-242H145q-21.66 0-38.46-13.5Q89.73-269 86-290L40-528q-8-44 19.7-77.5T131-639q32.07 0 57.53 20.5Q214-598 223-566l62 223h111q16.34 0 30.09 7.87Q439.83-327.25 448-313L575-96q6 11 3 23t-14 18ZM111.2-698Q82-698 61-718.8q-21-20.79-21-50Q40-798 60.8-819q20.79-21 50-21 29.2 0 50.2 20.8 21 20.79 21 50 0 29.2-20.8 50.2-20.79 21-50 21ZM665-521 517-670q-5-5-7-10.13-2-5.14-2-11 0-5.87 2-10.87 2-5 7-10l148-147q9-9 21-9t21 8.84q9 8.84 9 21T707-817l-96 96h239q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H612l96 98q8 9 8 21t-9 21q-9 9-21 9t-21-9Z"
		/>
	</svg>
);
